import type { AttendancePlayer } from '../types'

/**
 * A player's position as the attendance grid shows it: the full name
 * ("Goalkeeper"), falling back to the abbreviation ("GK") when the full name is
 * missing or blank. The Position column sorts by this same value.
 */
export const getPositionLabel = (
  player: Pick<AttendancePlayer, 'player_type'> | null | undefined
): string =>
  player?.player_type?.name_full?.trim() ||
  player?.player_type?.abbreviation ||
  ''
